import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetImport2ImportStatus as GetImport2ImportStatusQuery,
    GetImport2ImportStatusVariables as GetImport2ImportStatusQueryVariables,
    GetImport2ImportStatus_import2Import as Import,
} from 'nutshell-graphql-types';

import GET_IMPORT2_IMPORT_STATUS from '../queries/get-import2-import-status.graphql';

type Return = {
    importStatus: Import | null | undefined;
    isLoading: boolean;
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
    startPolling: (arg1: number) => void;
    stopPolling: () => void;
};

export const useGetImport2ImportStatus = (originId?: string | null): Return => {
    const {networkStatus, data, error, startPolling, stopPolling, refetch} = useQuery<
        GetImport2ImportStatusQuery,
        GetImport2ImportStatusQueryVariables
    >(GET_IMPORT2_IMPORT_STATUS, {
        fetchPolicy: 'cache-and-network',
        skip: !originId,
        // @ts-expect-error
        variables: {originId},
    });

    const import2Import = data ? data.import2Import : null;

    return {
        isLoading: isFirstLoad(networkStatus),
        importStatus: import2Import,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        refetch,
        startPolling,
        stopPolling,
    };
};
